import { useState, useEffect, useMemo } from 'react';
import api from '../utils/axiosInstance';
import BackButton from '../components/BackButton';
import { getLocalDateString } from '../utils/helpers';

export default function Logs() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const fetchLogs = async () => {
            setLoading(true);

            try {
                const response = await api.get('/invoco/logs');
                setLogs(response.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        fetchLogs();
    }, []);

    const handleClearFilters = () => {
        setSearchTerm('');
        setStartDate('');
        setEndDate('');
    }

    const formatDate = (date) => {
    if (!date) return null;
    return new Date(date).toISOString().split("T")[0];
    };

    const startString = formatDate(startDate);
    const endString = formatDate(endDate);

    const filteredLogs = useMemo(() => {
        return logs.filter(log => {
            const rowDate = getLocalDateString(log.timestamp);

            const inRange = (!startString || rowDate >= startString) && (!endString || rowDate <= endString);

            const matchesSearch = [log.doctor_name, log.room_name, log.location_id, log.status].some(field => (field || '').toString().toLowerCase().includes(searchTerm.toLowerCase()));

            return matchesSearch && inRange;
        })
    }, [logs, startString, endString, searchTerm])


    return (
        <div>
            <h3 className='text-xl font-bold mb-4 text-gray-700'>
                All Logs
            </h3>

            {/* Search by doctor, room, location, status and filter by dates */}
            <div className='mb-4'>
                <input type='text' placeholder='Search logs by doctor, room, location, or status' value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} className='border p-2 rounded w-full md:w-1/2' />
            </div>
            <div className='flex flex-col md:flex-row gap-4 mb-3 mx-1'>
                <div className='flex gap-4'>
                    <div className='flex gap-2 items-center'>
                        <label className='text-gray-600 text-sm'>From:</label>
                        <input type='date' value={startDate} onChange={(event) => setStartDate(event.target.value)} className='border p-2 rounded' />
                    </div>

                    <div className='flex gap-2 items-center'>
                        <label className='text-gray-600 text-sm'>To:</label>
                        <input type='date' value={endDate} onChange={(event) => setEndDate(event.target.value)} className='border p-2 rounded' />
                    </div>
                </div>

                {(searchTerm || startDate || endDate) && (
                    <div>
                        <button onClick={handleClearFilters} className='px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-200 transition text-sm'>Clear Filters</button>
                    </div>
                )}
            </div>

            {/* Logs Table  */}
            {loading ? (
                <p className='text-gray-500'>
                    Loading logs....
                </p>
            ) : filteredLogs.length === 0 ? (
                <p className='text-gray-500'>
                    No logs found.
                </p>
            ) : (
                <>
                {/* Desktop  */}
                <div className='hidden md:block overflow-x-auto bg-white rounded shadow-md p-4 max-h-[75vh] overflow-y-auto'>
                    <table className="min-w-full table-auto border-collapse">
                        <thead>
                            <tr className="bg-docpgrPurple10">
                                <th className="border px-4 py-2">
                                    Timestamp
                                </th>
                                <th className="border px-4 py-2">
                                    Location
                                </th>
                                <th className="border px-4 py-2">
                                    Room
                                </th>
                                <th className="border px-4 py-2">
                                    Doctor
                                </th>
                                <th className="border px-4 py-2">
                                    Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLogs.map(log => (
                                <tr key={log.log_id} className='hover:bg-gray-50'>
                                    <td className="border px-4 py-2">
                                        {new Date(log.timestamp).toLocaleString()}
                                    </td>
                                    <td className="border px-4 py-2">
                                        {log.location_id}
                                    </td>
                                    <td className="border px-4 py-2">
                                        {log.room_name}
                                    </td>
                                    <td className="border px-4 py-2">
                                        {log.doctor_name || '-'}
                                    </td>
                                    <td className="border px-4 py-2">
                                        {log.status}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

              {/* Mobile  */}
                <div className="block md:hidden space-y-3">
                    {filteredLogs.map((log) => (
                        <div key={log.log_id} className="border rounded-lg p-3 bg-white shadow-sm">
                            <p className="text-sm text-gray-600">
                                <span className='font-semibold text-gray-700'>Timestamp:</span>{' '}
                                {new Date(log.timestamp).toLocaleString()}
                            </p>
                            <p className="text-sm text-gray-600">
                                <span className='font-semibold text-gray-700'>Room:</span> {log.location_id || '-'}
                            </p>
                            <p className="text-sm text-gray-600">
                                <span className='font-semibold text-gray-700'>Doctor:</span>{' '}
                                {log.doctor_name || '-'}
                            </p>
                            <p className="text-sm text-gray-600">
                                <span className='font-semibold text-gray-700'>Status:</span> {log.status}
                            </p>
                        </div>
                    ))}
                
                </div>
                </>
            )}
            <div className='my-3'>
                <BackButton />
            </div>

        </div>
    )
}